import {
  ImportedNgModuleProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_LAGERSTAND } from './lagerstand.shared';

export const lagerstandProviders: (Provider | ImportedNgModuleProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'lagerstand',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#LAGERSTAND.APP',
      description: '#LAGERSTAND.APP_DESC',
      icon: 'fa-regular fa-boxes-stacked',
      route: '/lagerstand',
      permission: SOFTLINE_PERMISSION_LAGERSTAND,
      group: getModuleGroupByName('Lager'),
    });
  }),
];
